export const getMaxRangeValue = (
  rangeValue: number[] | undefined,
  maxLimit: number,
  includeProductsWithIncopmleteData: boolean,
) => {
  const maxLimitValue = !includeProductsWithIncopmleteData ? maxLimit : undefined;

  return !!rangeValue?.[1] && rangeValue?.[1] !== maxLimit ? rangeValue[1] : maxLimitValue;
};
